import { type PropsWithChildren } from 'react'
import { Platform, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { cn } from '~/lib/utils'

export function LayoutWrapper({
  children,
  className,
}: PropsWithChildren<{ className?: string; padded?: boolean }>) {
  const insets = useSafeAreaInsets()

  return (
    <View
      className={cn('relative isolate flex-1 bg-primary', className)}
      style={{
        paddingTop: Platform.select({
          native: insets.top,
        }),
        paddingBottom: Platform.select({
          native: insets.bottom,
        }),
      }}>
      {children}
    </View>
  )
}
